import { render, staticRenderFns } from "./ElementGeneral.vue?vue&type=template&id=560cd6ec"
import script from "./ElementGeneral.vue?vue&type=script&lang=ts"
export * from "./ElementGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports